import {injectReducer} from '../../shared/store';
import defaultContainerID from './defaultContainerID';
import partners from './partners';

// ETODO KST-1794 What's the correct way of having more than one file?
injectReducer('defaultContainerID', defaultContainerID);
injectReducer('partners', partners);
